// extracted by mini-css-extract-plugin
export default {"wrapper":"tp","form":"up","option":"vp","radio":"wp","success":"xp","contest":"yp"};